import { SiteIntegrationTypeEnum } from '@beable/roster-backend-client-v1';
import { makeAutoObservable } from 'mobx';
import {
  CustomerSetupCleverAPIForm,
  CustomerSetupOneRosterAPIForm,
  CustomerSetupOneRosterCSVForm
} from './RosterSource.form';
import { MRF } from '../../../interfaces/MRF';
import { ORAPIClientConfigDTO } from '@beable/roster-backend-client-v1';

export class CustomerSetupStore {
  integrationType: SiteIntegrationTypeEnum = SiteIntegrationTypeEnum.OneRosterCSV;
  customerSetupOneRosterCSVForm = new CustomerSetupOneRosterCSVForm() as unknown as MRF;
  customerSetupOneRosterAPIForm = new CustomerSetupOneRosterAPIForm() as unknown as MRF;
  customerSetupCleverAPIForm = new CustomerSetupCleverAPIForm() as unknown as MRF;

  constructor() {
    makeAutoObservable(this);
  }

  savedSettings?: ORAPIClientConfigDTO;
  previousIntegrationType?: SiteIntegrationTypeEnum;

  /**
   * Selecting integration partner (OneRoster, Clever, etc.)
   */
  handleIntegrationTypeChange(event: any) {
    this.integrationType = event.currentTarget.value as SiteIntegrationTypeEnum;
  }
}
